import { ArticleView } from '@roc-digital/ui-web';
import { ArticleViewProps } from '@roc-digital/ui-lib';
import { Icon } from '../Icon';
import React from 'react';

interface ArticleViewContainerProps {
  onMenu: (event: MouseEvent, articleId: string) => void;
  isStatic?: boolean;
}
export function ArticleViewContainer(props: ArticleViewContainerProps & ArticleViewProps) {
  const onMenu = React.useCallback((event: any) => {
      props.onMenu(event, props.article?.id);
  }, [props.onMenu, props.article?.id]);

  return <>
    <ArticleView {...props} className={props.className + ' relative'}>
      {/* <div style={{position: 'absolute', top: 8, left: 8, borderRadius: 28, width: 28, height: 28, cursor: 'pointer', boxShadow: '1px 2px 8px black', backgroundColor: '#24AAE1'}} onClick={onMenu} className='flex justify-center items-center button-type'>
        <span style={{color: 'white'}}>{props.isStatic === true ? 'A' : 'T'}</span>
      </div> */}
      <div style={{position: 'absolute', top: 8, right: 8, borderRadius: 24, width: 24, height: 24, cursor: 'pointer', boxShadow: '1px 2px 8px black', backgroundColor: '#24AAE1'}} onClick={onMenu} className='flex justify-center items-center button-type'>
      <span style={{color: 'white', fontSize: 16}}>{props.isStatic === true ? 'A' : 'T'}</span>
      </div>
    </ArticleView>
  </>
}

export function createArticleViewContainer(onMenu: (event: MouseEvent, articleId: string) => void) {
  return (props: ArticleViewProps) => {
    return <ArticleViewContainer {...props} onMenu={(e) => onMenu(e, props.article.id)}/>
  }
}

const icon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="white" viewBox="0 0 256 256"><path d="M156,128a28,28,0,1,1-28-28A28,28,0,0,1,156,128ZM128,76a28,28,0,1,0-28-28A28,28,0,0,0,128,76Zm0,104a28,28,0,1,0,28,28A28,28,0,0,0,128,180Z"></path></svg>`